import { Box } from "@mui/material";
import MainHelloComponent from "../main-hello-component/main-hello-component";
import InfoComponent from "../info-component/info-component";
import PrivacyNotice from "../Politics/politics";

export default function HomePage() {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: '100vw', 
                overflowX: 'hidden',  
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxSizing: "border-box",
            }}
        >
            <MainHelloComponent />
            <InfoComponent />
            <PrivacyNotice />
        </Box >
    );
}